<div class="direction-arrow-container">
  <svg [style.transform]="'rotate(' + heading + 'rad)'" viewBox="0 0 24 24" style="width: 100px; height: 100px;">
    <path d="M12 8L14 22L12 18L10 22L12 8Z" fill="#1e72a3" opacity="0.7" />
  </svg>
</div>